module.exports = __webpack_public_path__ + "static/media/feature2support.e146f2db.png";